(function () {
  'use strict';

  const root = document.querySelector('[data-pl-boutiques]');
  if (!root) return;

  /* ---------- City filter pills ---------- */
  const pills = root.querySelectorAll('[data-pl-filter]');
  const cards = root.querySelectorAll('[data-pl-boutique-card]');

  pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      const target = pill.getAttribute('data-pl-filter');
      pills.forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      cards.forEach(function (card) {
        const city = card.getAttribute('data-city') || '';
        if (target === 'all' || city === target) {
          card.classList.remove('is-filtered-out');
        } else {
          card.classList.add('is-filtered-out');
        }
      });
      updateStickyForViewport();
    });
  });

  /* ---------- Time helpers ---------- */
  function parseHMM(s) {
    if (!s) return null;
    const m = String(s).trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return null;
    const h = parseInt(m[1], 10);
    const mm = parseInt(m[2], 10);
    if (isNaN(h) || isNaN(mm)) return null;
    return h * 60 + mm;
  }

  function parseDay(s) {
    if (!s) return null;
    const t = String(s).trim().toLowerCase();
    if (t === '' || t === 'closed' || t === 'gesloten') return null;
    const parts = t.split('-');
    if (parts.length !== 2) return null;
    const open = parseHMM(parts[0]);
    const close = parseHMM(parts[1]);
    if (open == null || close == null) return null;
    return { open: open, close: close };
  }

  function nowInAmsterdam() {
    try {
      const str = new Date().toLocaleString('en-US', { timeZone: 'Europe/Amsterdam' });
      const d = new Date(str);
      if (isNaN(d.getTime())) return new Date();
      return d;
    } catch (e) {
      return new Date();
    }
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function fmt(min) {
    const h = Math.floor(min / 60);
    const m = min % 60;
    return pad(h) + ':' + pad(m);
  }

  function computeStatus(hoursStr) {
    // Returns { isOpen, text } or null if can't parse.
    if (!hoursStr) return null;
    const days = hoursStr.split(',').map(function (s) { return s.trim(); });
    if (days.length < 7) return null;
    const now = nowInAmsterdam();
    const jsDay = now.getDay();
    const monIdx = (jsDay + 6) % 7;
    const nowMin = now.getHours() * 60 + now.getMinutes();
    const today = parseDay(days[monIdx]);

    if (today && nowMin >= today.open && nowMin < today.close) {
      return { isOpen: true, text: 'Nu open · tot ' + fmt(today.close) };
    }
    if (today && nowMin < today.open) {
      return { isOpen: false, text: 'Gesloten · opent vandaag ' + fmt(today.open) };
    }
    let nextOpen = null;
    for (let i = 1; i <= 7; i++) {
      const idx = (monIdx + i) % 7;
      const d = parseDay(days[idx]);
      if (d) { nextOpen = { idx: idx, open: d.open }; break; }
    }
    if (nextOpen) {
      const dayNames = ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'];
      return { isOpen: false, text: 'Gesloten · ' + dayNames[nextOpen.idx] + ' ' + fmt(nextOpen.open) };
    }
    return { isOpen: false, text: 'Gesloten' };
  }

  /* ---------- Open-now indicator on each card ---------- */
  function updateCard(card) {
    const hoursStr = card.getAttribute('data-hours') || '';
    const status = computeStatus(hoursStr);
    const statusEl = card.querySelector('[data-pl-status]');
    const dotEl = card.querySelector('[data-pl-dot]');
    const textEl = card.querySelector('[data-pl-status-text]');
    if (!statusEl || !dotEl || !textEl) return;
    if (!status) return;
    if (status.isOpen) dotEl.classList.add('is-open');
    textEl.textContent = status.text;
    statusEl.classList.add('is-ready');
  }
  cards.forEach(updateCard);

  /* ---------- Sticky CTA bar ---------- */
  const sticky = root.querySelector('[data-pl-sticky]');
  const stickyCity = sticky && sticky.querySelector('[data-pl-sticky-city]');
  const stickyStreet = sticky && sticky.querySelector('[data-pl-sticky-street]');
  const stickyDot = sticky && sticky.querySelector('[data-pl-sticky-dot]');
  const stickyStatusText = sticky && sticky.querySelector('[data-pl-sticky-status-text]');
  const stickyCall = sticky && sticky.querySelector('[data-pl-sticky-call]');
  const stickyWa = sticky && sticky.querySelector('[data-pl-sticky-wa]');
  const stickyMaps = sticky && sticky.querySelector('[data-pl-sticky-maps]');
  const stickyTour = sticky && sticky.querySelector('[data-pl-sticky-tour]');

  let currentCard = null;
  let stickyShown = false;

  function showSticky() {
    if (!sticky) return;
    sticky.hidden = false;
    document.body.classList.add('pl-bt-sticky-active');
    stickyShown = true;
  }
  function hideSticky() {
    if (!sticky) return;
    sticky.hidden = true;
    document.body.classList.remove('pl-bt-sticky-active');
    stickyShown = false;
    currentCard = null;
    cards.forEach(function (c) { c.classList.remove('is-active'); });
  }

  function setOptional(el, value, hrefBuilder) {
    if (!el) return;
    if (value) {
      if (hrefBuilder) el.setAttribute('href', hrefBuilder(value));
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function bindSticky(card) {
    if (!sticky || !card) return;
    if (currentCard === card) return;
    currentCard = card;
    cards.forEach(function (c) { c.classList.toggle('is-active', c === card); });

    const cityText = card.getAttribute('data-city') || '';
    const name = card.getAttribute('data-name') || '';
    // Split name "City — Street"
    let cityLabel = cityText.charAt(0).toUpperCase() + cityText.slice(1);
    let streetLabel = name;
    const sep = name.indexOf(' — ');
    if (sep > -1) {
      cityLabel = name.slice(0, sep);
      streetLabel = name.slice(sep + 3);
    }
    if (stickyCity) stickyCity.textContent = cityLabel;
    if (stickyStreet) stickyStreet.textContent = streetLabel;

    const status = computeStatus(card.getAttribute('data-hours') || '');
    if (stickyDot) stickyDot.classList.toggle('is-open', !!(status && status.isOpen));
    if (stickyStatusText) stickyStatusText.textContent = status ? status.text : '';

    const tel = card.getAttribute('data-tel');
    const wa = card.getAttribute('data-whatsapp');
    const maps = card.getAttribute('data-maps');
    const tour = card.getAttribute('data-tour');

    setOptional(stickyCall, tel, function (v) { return 'tel:' + v; });
    setOptional(stickyWa, wa, function (v) {
      const msg = encodeURIComponent('Hi, ik heb een vraag over de Pure Lust boutique ' + streetLabel + '.');
      return 'https://wa.me/' + v + '?text=' + msg;
    });
    setOptional(stickyMaps, maps, function (v) { return v; });

    if (stickyTour) {
      if (tour) {
        stickyTour.hidden = false;
        stickyTour.setAttribute('data-tour-url', tour);
        stickyTour.setAttribute('data-tour-city', cityLabel);
        stickyTour.setAttribute('data-tour-street', streetLabel);
      } else {
        stickyTour.hidden = true;
      }
    }
  }

  function updateStickyForViewport() {
    if (!sticky) return;
    const visibleCards = Array.from(cards).filter(function (c) {
      return !c.classList.contains('is-filtered-out');
    });
    if (visibleCards.length === 0) { hideSticky(); return; }

    const grid = root.querySelector('[data-pl-grid]');
    if (!grid) return;
    const gridRect = grid.getBoundingClientRect();
    const viewportH = window.innerHeight || document.documentElement.clientHeight;

    // Hide when grid is entirely below or above viewport
    if (gridRect.bottom < 80 || gridRect.top > viewportH - 80) {
      hideSticky();
      return;
    }

    // Find card whose vertical center is closest to viewport center
    const targetY = viewportH * 0.5;
    let bestCard = null;
    let bestDist = Infinity;
    visibleCards.forEach(function (c) {
      const r = c.getBoundingClientRect();
      if (r.bottom < 0 || r.top > viewportH) return;
      const center = r.top + r.height / 2;
      const d = Math.abs(center - targetY);
      if (d < bestDist) { bestDist = d; bestCard = c; }
    });

    if (!bestCard) { hideSticky(); return; }
    if (!stickyShown) showSticky();
    bindSticky(bestCard);
  }

  let scrollTick = false;
  function onScroll() {
    if (scrollTick) return;
    scrollTick = true;
    requestAnimationFrame(function () {
      updateStickyForViewport();
      scrollTick = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // Initial measurement after layout settles
  setTimeout(updateStickyForViewport, 250);

  /* ---------- 3D tour modal ---------- */
  const modal = root.querySelector('[data-pl-tour-modal]');
  const frame = modal && modal.querySelector('[data-pl-tour-frame]');
  const titleEl = modal && modal.querySelector('[data-pl-tour-title]');
  const closeBtn = modal && modal.querySelector('[data-pl-tour-close]');
  const tourBtns = root.querySelectorAll('[data-pl-boutique-tour]');
  let lastTrigger = null;

  function isExternalShareUrl(url) {
    // Google Maps share URLs cannot be iframed (X-Frame-Options). The official
    // embed form (/maps/embed?pb=...) DOES iframe — allow those.
    if (/google\.[a-z.]+\/maps\/embed\b/i.test(url)) return false;
    return /google\.[a-z.]+\/maps|maps\.app\.goo\.gl/i.test(url);
  }

  function openTour(opts) {
    if (!modal || !frame) return;
    const url = opts.url;
    const city = opts.city || '';
    const street = opts.street || '';
    const trigger = opts.trigger || null;
    if (!url) return;

    if (isExternalShareUrl(url)) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    lastTrigger = trigger;
    if (titleEl) {
      const label = [city, street].filter(Boolean).join(' — ');
      titleEl.textContent = label || '—';
    }

    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', url);
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'xr-spatial-tracking; fullscreen; accelerometer; gyroscope; magnetometer');
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    frame.innerHTML = '';
    frame.appendChild(iframe);

    modal.removeAttribute('hidden');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.body.classList.add('pl-tour-open');

    if (closeBtn) {
      try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
    }
  }

  function closeTour() {
    if (!modal || !frame) return;
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    frame.innerHTML = '';
    document.body.classList.remove('pl-tour-open');
    if (lastTrigger) {
      try { lastTrigger.focus({ preventScroll: true }); } catch (e) { lastTrigger.focus(); }
      lastTrigger = null;
    }
  }

  tourBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openTour({
        url: btn.getAttribute('data-tour-url'),
        city: btn.getAttribute('data-tour-city'),
        street: btn.getAttribute('data-tour-street'),
        trigger: btn
      });
    });
  });

  if (stickyTour) {
    stickyTour.addEventListener('click', function (e) {
      e.preventDefault();
      openTour({
        url: stickyTour.getAttribute('data-tour-url'),
        city: stickyTour.getAttribute('data-tour-city'),
        street: stickyTour.getAttribute('data-tour-street'),
        trigger: stickyTour
      });
    });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeTour);
  }

  if (modal) {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeTour();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (!modal || modal.hasAttribute('hidden')) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      closeTour();
    }
  });
})();
